"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_jss_1 = __importDefault(require("react-jss"));

var AddressInputAccount_1 = __importDefault(require("./AddressInputAccount"));

var constants_1 = require("../constants");

var ADDRESS_REGEX = /^(0x)?[0-9a-f]{40}$/i;
var styles = {
  inputContainer: {
    border: 'solid 1px #CCCCCC',
    borderRadius: 4,
    display: 'flex',
    padding: 1,
    height: 40
  },
  textField: {
    border: 'none',
    flex: '1 0',
    fontSize: 16,
    padding: 4
  },
  scanBtn: {
    backgroundImage: "url(\"" + constants_1.SCAN_QR_DATAURI + "\")",
    width: 40,
    height: 40
  },
  clearBtn: {
    width: 40
  }
};

var AddressInputField = function AddressInputField(_a) {
  var value = _a.value,
      account = _a.account,
      _onChange = _a.onChange,
      scan = _a.scan,
      disabled = _a.disabled,
      classes = _a.classes;
  var _account = account;

  if (!account && ADDRESS_REGEX.test(value)) {
    _account = {
      address: value
    };
  }

  return react_1.default.createElement("div", {
    className: classes.inputContainer
  }, _account ? react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(AddressInputAccount_1.default, {
    account: _account
  }), react_1.default.createElement("button", {
    onClick: function onClick() {
      return _onChange('', null);
    },
    className: classes.clearBtn
  }, "\xD7")) : react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement("input", {
    className: classes.textField,
    value: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value, null);
    }
  }), scan && react_1.default.createElement("button", {
    className: classes.scanBtn,
    onClick: scan
  })));
};

exports.default = react_jss_1.default(styles)(AddressInputField);